import { styled } from '@linaria/react';
import { useCallback, useContext } from 'react';
import { GlobalContext } from '../../contexts';
import { newCOLORS } from '../../styles/colors';
import { baseBlack, baseWhite } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';
import type { GlobalMessage } from './global-message.type';
import { GlobalMessageType } from './global-message.type';

type Props = {
  globalMessage: GlobalMessage;
};

export function GlobalMessageComponent({ globalMessage }: Props) {
  const { setGlobalMessage } = useContext(GlobalContext);

  const closeHandler = useCallback(() => {
    setGlobalMessage(null);
  }, [setGlobalMessage]);

  const messageType = globalMessage.type || GlobalMessageType.ERROR;
  const isError = messageType === GlobalMessageType.ERROR;

  return (
    <ContentContainer isError={isError} role="alert" aria-live="polite">
      <MessageText isError={isError}>{globalMessage.message}</MessageText>
      <CloseIconWrapper>
        <Icon
          name="close"
          color={isError ? baseWhite : baseBlack}
          size={28}
          pointer
          onClick={closeHandler}
          aria-label="Close message"
        />
      </CloseIconWrapper>
    </ContentContainer>
  );
}

const ContentContainer = styled.div<{ isError: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background-color: ${(props) => (props.isError ? newCOLORS.red : newCOLORS.yellow)};
  padding: 0em 2em;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
`;

const MessageText = styled.div<{ isError: boolean }>`
  color: ${(props) => (props.isError ? baseWhite : baseBlack)};
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  flex: 1;
  padding-right: 3em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  right: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
